import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";
import METASTORE_CSRF_TOKEN from "components/constant/constant";
import { AccessToken } from "types";

/**
 * Authentication state in Redux
 */
export interface AuthState {
  accessToken?: AccessToken;
}

/**
 * Initial authentication state
 */
const initialState: AuthState = {
  accessToken: undefined
};

/**
 * Authentication slice of Redux store
 */
export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, { payload }: PayloadAction<AuthState>) => {
      const { accessToken } = payload;
      accessToken?.csrf_token && localStorage.setItem(METASTORE_CSRF_TOKEN, accessToken.csrf_token);
      state.accessToken = payload.accessToken;
    },
    logout: state => {
      localStorage.removeItem(METASTORE_CSRF_TOKEN);
      state.accessToken = undefined;
    }
  }
});

/**
 * Authentication actions from created authentication slice
 */
export const { login, logout } = authSlice.actions;

/**
 * Select Keycloak selector
 *
 * @param state Redux store root state
 * @returns keycloak instance from Redux store
 */
export const selectAccessToken = (state: RootState) => state.auth.accessToken;

/**
 * Reducer from authentication slice
 */
export default authSlice.reducer;